import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const AccountFill = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="account-fill"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      viewBox="0 0 25 25"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="13" cy="7.5" r="4.5" />
      <path d="M13 12.9C9.06108 12.9 5.71316 15.4304 4.49312 18.9543C3.95105 20.52 5.34315 21.9 7 21.9H19C20.6569 21.9 22.0489 20.52 21.5069 18.9543C20.2868 15.4304 16.9389 12.9 13 12.9Z" />
    </svg>
  );
};
/* eslint-enable max-len */

AccountFill.defaultProps = {
  className: null,
};

AccountFill.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default AccountFill;
